/** First offline → ping wait (ms). */
export const CONNECTIVITY_PING_INITIAL_MS = 250

/** Cap: one ping every other second once backoff has grown. */
export const CONNECTIVITY_PING_MAX_MS = 2_000

/**
 * Temporary reachability probe path — repurposes an existing lightweight GET until a dedicated
 * connectivity endpoint exists.
 *
 * NOTE: Replace with a purpose-built route (e.g. `GET /api/connectivity/ping`) that returns a
 * minimal stub with no domain coupling, no auth requirement, and no DB / Flagship work. Update
 * {@link CONNECTIVITY_PING_PATH} and the network store recovery ping when that route ships.
 *
 * @see `layers/base/server/api/handwriting_stationery/signature-stub.get.ts`
 */
export const CONNECTIVITY_PING_PATH = '/api/handwriting_stationery/signature-stub'

/**
 * Delay before the next connectivity recovery ping.
 *
 * `failedAttemptCount` is how many pings have already failed in this offline spell
 * (0 = about to fire the first ping). Grows 250 → 500 → 1000 → 2000ms and stays at 2000
 * ("every other second").
 */
export function nextConnectivityPingDelayMs(failedAttemptCount: number): number {
    const safeAttempt = Math.max(0, Math.floor(failedAttemptCount))
    return Math.min(CONNECTIVITY_PING_INITIAL_MS * 2 ** safeAttempt, CONNECTIVITY_PING_MAX_MS)
}
